module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "fmh",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062847355_Contents#r_idParaDest-2"
    }
  }, [_c('i', [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  })]), _vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("TO ALL OF THE FRIENDS I’VE FOUND")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("ALONG THE WAY,")]), _vm._v(" "), _c('p', {
    staticClass: "dedi"
  }, [_vm._v("AND ALL THE ONES LEFT TO FIND.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84d6fa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062847355_Dedication.vue
// module id = 60
// module chunks = 0